module.exports = __webpack_public_path__ + "img/myluxura-module.bb9206a2.svg";